import { styles as commonStyles } from '../../../base/styles/common.scss';
import { styles as styleHelpersStyles } from '../../../../../assets/style-helpers.scss';
export const templateAtlassianAuditSensor = document.createElement('template');

templateAtlassianAuditSensor.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styleHelpersStyles}</style>
  <div class="form-wrapper" id="integration-types">
    <gz-form-field  class="sensor-select-wrapper mb-2">
       <gz-checkbox gz-form-input class="sensor-select" style="display: none" checked></gz-checkbox>
    </gz-form-field>
    <div class="sensor-data">
      <div class="sensor-data-list">
        <gz-form-field label="" id="atlassian_organization_id" stacked required>
        <gz-input gz-form-input="" type="text" ></gz-input>
        <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field label="" id="atlassian_admin_api_key" stacked required>
        <gz-input gz-form-input="" type="password" ></gz-input>
        <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
    </div>
    <gz-form-field label="" id="response_actions_form">
      <gz-checkbox gz-form-input class="response_actions_checkbox" ></gz-checkbox>
    </gz-form-field>
    <gz-input-error id="response_actions_error"></gz-input-error>
  </div>
`;
